<script lang="ts">
  import type { MenuPath } from "./menu-nav";
  import type { MenuItem } from "./MenuItem";
  import MenuItems from "./MenuItems.svelte";
  import { len } from "./util";

  interface Props {
    menu?: MenuItem[];
    // what is selected in this menu and the sub-menus open under it
    path?: MenuPath;
    // the path of the item this menu is the sub-menu of
    prefix?: MenuPath;
    onselect?: (path: MenuPath) => void;
  }

  let { menu = [], path = [], prefix = [], onselect = () => {} }: Props = $props();

  function itemClicked(item: MenuItem) {
    // console.log("MenuItems: itemClicked:", item);
    if (item.handler) {
      item.handler();
    }
  }

  // the item under a moving mouse becomes the selected one
  function mouseMoved(ev: MouseEvent, idx: number) {
    // not for the menus this one is a sub-menu of
    ev.stopPropagation();
    if (len(path) == 1 && path[0] == idx) {
      return;
    }
    onselect([...prefix, idx]);
  }
</script>

<div class="select-none bg-white min-w-[120px] px-0 py-0 border-2 border-gray-200 drop-shadow-lg">
  {#each menu as item, idx}
    {#if item.isSeparator()}
      <hr class="w-full m-0 border-1 border-gray-300" />
    {:else if len(item.items) > 0}
      <!-- svelte-ignore a11y_no_static_element_interactions -->
      <div
        class="submenu-wrapper w-full flex flex-row justify-between text-sm py-1 px-4"
        class:bg-gray-200={path[0] == idx}
        class:open={path[0] == idx && len(path) > 1}
        onmousemove={(ev) => mouseMoved(ev, idx)}
      >
        <div>
          {item.label}
        </div>
        <div>&gt;</div>
        <div class="submenu relative left-0">
          <MenuItems
            menu={item.items}
            path={path[0] == idx ? path.slice(1) : []}
            prefix={[...prefix, idx]}
            {onselect}
          />
        </div>
      </div>
    {:else}
      <button
        class="flex w-full whitespace-nowrap justify-between place-items-center text-left text-sm py-1 px-4"
        class:bg-gray-200={path[0] == idx}
        tabindex="-1"
        onclick={() => itemClicked(item)}
        onmousemove={(ev) => mouseMoved(ev, idx)}
      >
        <div class="max-w-[32ch] truncate">
          {@html item.label}
        </div>
        {#if item.shortcut}
          <div class="ml-4 text-gray-600 text-sm">{item.shortcut}</div>
        {/if}
      </button>
    {/if}
  {/each}
</div>

<style lang="postcss">
  .submenu {
    display: none;
  }
  .submenu-wrapper:hover > .submenu,
  .submenu-wrapper.open > .submenu {
    display: flex;
  }
</style>
